<template>
    <div class="chart-wrap">
        <!-- 杩戜竴骞存礂娑ら噺瓒嬪娍 -->
        <Echart :options="options" id="washingVolumeChart" height="100%" width="100%"></Echart>
    </div>
</template>

<script>
import Echart from '@/common/echart'

export default {
    data() {
        return {
            options: {},
        };
    },
    components: {
        Echart,
    },
    props: {
        cdata: {
            type: Object,
            default: () => ({})
        },
    },
    watch: {
        cdata: {
            handler(newData) {
                if (!newData.seriesData || newData.seriesData.length === 0) {
                    return
                }
                
                let max = 0
                max = Math.max(...newData.seriesData.map(item => item.value))
                console.log(newData, max, 'washingVolume seriesData------')

                let _this = this
                _this.options = {
                    tooltip: {
                        trigger: "axis",
                        backgroundColor: "rgba(255,255,255,0.1)",
                        axisPointer: {
                            type: "shadow",
                            label: {
                                show: true,
                                backgroundColor: "#7B7DDC"
                            }
                        },
                        textStyle: {
                            fontSize: 12,
                        },
                        transitionDuration: 0,
                        formatter: function (params) {
                            var result = `<span>月份 : ${params[0].name}</span>`
                            result += `<div style="margin-top: 10px">洗涤量: ${params[0].value}</div>`
                            if (params[0].data.remark) {
                                result += `<div style="margin-top: 5px">备注 : ${params[0].data.remark}</div>`
                            }
                            return result;
                        }
                    },
                    grid: {
                        top: "14%",
                        left: "17%",
                        right: "10%",
                        bottom: "58%"
                    },
                    xAxis: {
                        name: '',
                        nameTextStyle: {
                            fontSize: 11
                        },
                        data: newData.xAxis,
                        axisLine: {
                            lineStyle: {
                                color: "rgba(161,164,165,0.5)"
                            }
                        },
                        axisLabel: {
                            rotate: 28,
                            textStyle: {
                                fontSize: 11
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: {
                        max: max + 10,
                        name: '洗涤量',
                        nameTextStyle: {
                            fontSize: 11
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "rgba(161,164,165,0.5)"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "rgba(161,164,165,0.5)"
                            }
                        },
                        axisLabel: {
                            formatter: function (params) {
                                return params
                            },
                            textStyle: {
                                fontSize: 11
                            }
                        }
                    },
                    series: [
                        {
                            name: '洗涤量',
                            type: 'bar',
                            barWidth: '52%',
                            data: newData.seriesData,
                            itemStyle: {
                                color: '#37a2da'
                            }
                        }
                    ]
                }
                
                // keep fixed safe layout, avoid overflow on larger resolutions
                _this.options.grid = {
                    top: "10%",
                    left: "8%",
                    right: "6%",
                    bottom: "12%",
                    containLabel: true
                }
                _this.options.tooltip.textStyle.fontSize = 12
                _this.options.xAxis.nameTextStyle.fontSize = 11
                _this.options.xAxis.axisLabel.textStyle.fontSize = 11
                _this.options.yAxis.nameTextStyle.fontSize = 11
                _this.options.yAxis.axisLabel.textStyle.fontSize = 11

            },
            immediate: true,
            deep: true
        },
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.chart-wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
</style>
